import { Link } from "react-router-dom";

export default function FooterCTA() {
  return (
    <section className="relative py-32 overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/ab5cdf761352f1a3a175dada007a226d.jpg"
          alt="Calm interior"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-[#FAF7F0]/85" />
      </div>

      <div className="relative z-10 text-center px-8">
        <p
          className="text-[#B5A898] text-[10px] tracking-[0.45em] uppercase mb-6"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Start Your Journey
        </p>
        <h2
          className="text-[#2C2825] text-4xl md:text-5xl lg:text-6xl mb-8"
          style={{ fontFamily: "'Playfair Display', serif", fontWeight: 400 }}
        >
          Find your next <em>calm corner</em>
        </h2>
        <Link
          to="/cozy-corners"
          className="inline-flex items-center gap-2.5 bg-[#2C2825] text-[#FAF7F0] px-11 py-4 rounded-full text-xs tracking-[0.2em] hover:bg-[#3A3632] transition-colors cursor-pointer whitespace-nowrap uppercase"
          style={{ fontFamily: "'Inter', sans-serif" }}
        >
          Start Exploring
          <span className="w-4 h-4 flex items-center justify-center">
            <i className="ri-arrow-right-line text-xs" />
          </span>
        </Link>
      </div>
    </section>
  );
}
